import React from "react";
import { observable, toJS } from "mobx";
import {appendFieldSpan, montarSelectOption, situacaoFormatter, splitBR, listEmailFormatter, dataSortFuncString} from "../../../utils/formatar";
import {buscaFiltrarVazio, buscaSemResultado} from "../../../utils/mensagens";
import {IconeDelete, sortCaret} from "../../comum/components/Icones";
import LoadingImage from "../../comum/components/LoadingImage";
import {Row, Col, Container, FormGroup, Label, Button} from 'reactstrap';

export default class CargaGeralStore {
  // Area de inclusão
  @observable inserindo;
  @observable inserindoXls;
  estadoFiltros;
  @observable novasCargas;
  novasCargasLength;
  @observable naviosFiltros;
  @observable loadingNavios;
  @observable colunasN;
  @observable noData;
  @observable itens;
  toShow;
  turn;
  @observable selecionados;
  @observable hasMore;
  @observable cargasLista;
  @observable lista;
  @observable loading;
  @observable tableMessage;
  @observable mockDados;
  @observable inativandoLoading;
  @observable modalInativar;
  @observable outrosDados;
  @observable posEditando;
  @observable listaMensagens;
  @observable salvando;
  @observable sucessoInserirAgendamentos;

  constructor(service) {
    // Area de inclusão
    this.listaMensagens = false;
    this.posEditando = -1;
    this.inserindo = false;
    this.salvando = false;
    this.inserindoXls = false;
    this.novasCargas = [];
    this.naviosFiltros = false;
    this.loadingNavios = true;
    this.colunasN = this.colunasNovas;
    this.noData = <LoadingImage />;
    this.novasCabotagensLength = 0;
    this.colunas = this.todasColunas;
    this.toShow = 20;
    this.turn = 0;
    this.itens = [];
    this.selecionados = [];
    this.hasMore = false;
    this.cargasLista = [];
    this.lista = [];
    this.loading = false;
    this.tableMessage = buscaFiltrarVazio;
    this.estadoFiltros = false;
    this.mockDados = [];
    this.service = service;
    this.inativandoLoading = false;
    this.modalInativar = false;
    this.sucessoInserirAgendamentos = false;
    this.outrosDados = [
      { titulo: "Cliente", field: ["NomeCriador"], id: "F1", hidden: false },
      {
        titulo: "Criado por",
        field: ["UsuarioCriacao"],
        id: "F2",
        hidden: false,
      },
      {
        titulo: "Inativado por",
        field: ["UsuarioCancelamento"],
        id: "F3",
        hidden: false,
      },
      {
        titulo: "Email",
        formatter: listEmailFormatter,
        field: ["EmailCriador"],
        id: "F4",
        hidden: false,
      },
      { titulo: "Observacao", field: ["Observacao"], id: "F5", hidden: false },
    ];
  }

  cancelaInativar = () => {
    this.modalInativar = false;
  };

  confirmarInativar = () => {
    this.inativandoLoading = true;
    this.service.inativar(this.selecionados).then((response) => {
      this.modalInativar = false;
      if (response.data) {
        this.sucessoInserirCabotagem = response.data.Sucesso;
        this.listaMensagens = splitBR(response.data.Mensagem);
        if(response.data.MensagemErro) this.listaMensagens.push(splitBR(response.data.MensagemErro));
        if(response.data.MensagemAlerta) this.listaMensagens.push(splitBR(response.data.MensagemAlerta));
        this.reListar();
      } else {
        this.listaMensagens = "Problemas ao tentar inativar";
      }
    }).catch((err=> {
        console.log(err);
      })).finally(() => {this.inativandoLoading = false;});
  };

  salvarNovas = () => {
    this.salvando = true;

    this.service
      .salvar(this.novasCargas)
      .then((response) => {
        if (response.data && response.status != 409) {
          this.sucessoInserirAgendamentos = response.data.Sucesso;
          this.listaMensagens = splitBR(response.data.Mensagem);

          if (response.data.MensagemErro)
            this.listaMensagens.push(splitBR(response.data.MensagemErro));

          if (response.data.MensagemAlerta)
            this.listaMensagens.push(splitBR(response.data.MensagemAlerta));
          
          if (this.sucessoInserirAgendamentos || response.data.Mensagem.includes("Agendamento salvo com sucesso") ||  response.data.MensagemAlerta.includes("Agendamento salvo com sucesso")) {  //pedido para limpar a lista se ao menos um agendamento for salvo
            this.cancelarEnviar();
            if (this.estadoFiltros) this.reListar();
          }

        } else if (response.status == 409)
          this.listaMensagens = splitBR(response.data);
        else {
          this.listaMensagens = splitBR("Problemas ao salvar");
        }
        
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {this.salvando = false;});
  };

  incluirListaCargaGeral = (listaNovas, navio) => {
    if (this.novasCargas.length === 0) this.novasCargasLength = 0;
    listaNovas.map((n) => {
      n.pos = this.novasCargasLength;
      n.Navio = navio.label;
      n.OperacaoId = navio.value;
      this.novasCargasLength++;
      this.novasCargas.push(n);

      this.inserindoXls = false;
    });
  };

  abrirModalInativar = () => {
    this.modalInativar = true;
  };

  cancelarEnviar = () => {
    this.novasCargas = [];
    this.novasCargasLength = 0;
  };

  carregarDadosNavio = () => {
    //criar rotina com service depois!
    this.service.listarOperaçoes().then((response) => {
      if (response.data) {
        this.naviosFiltros = montarSelectOption(
          "CvGkey",
          "Name",
          response.data
        );
        this.loadingNavios = false;
      }
    });
  };

  carregarDadosNavioAgend = () => {
    //criar rotina com service depois!
    this.service.listarOperaçoesAgend().then((response) => {
      if (response.data) {
        this.naviosFiltrosAgend = montarSelectOption(
          "CvGkey",
          "Name",
          response.data
        );
        this.loadingNaviosAgend = false;
      }
    });
  };

  listar(filtros) {
    this.estadoFiltros = filtros;
    this.fazerListar(filtros);
  }

  fazerListar = (filtros) => {
    this.selecionados = [];
    this.cargasLista = [];
    this.lista = [];
    this.itens = [];
    this.loading = true;
    this.service
      .listar(filtros.operacao, filtros.placa, filtros.cpf, filtros.cnh, filtros.status, filtros.utilizado)
      .then((response) => {
        this.loading = false;
        if (response.data) {
          this.cargasLista = response.data;
        }
        if (this.cargasLista.length === 0) {
          this.tableMessage = buscaSemResultado;
        } else {
          this.tableMessage = buscaFiltrarVazio;
        }
        this.lista = this.cargasLista;

        this.noData = this.tableMessage;
        this.loadFirstTurn();
      });
  };

  reListar = () => {
    this.fazerListar(this.estadoFiltros);
  };

  marcar = (carga) => {
    carga.marcado = !carga.marcado;
    this.selecionados = this.itens.filter((i) => i.marcado === true);
  };

  loadFirstTurn = () => {

    this.itens = this.cargasLista.slice(0, this.toShow);
    this.turn = 1;
    this.hasMore = this.itens.length < this.lista.length;
  };

  loadNextTurn = () => {
    this.itens = [];
    this.itens = this.lista.slice(0, (this.turn + 1) * this.toShow);
    this.turn = this.turn + 1;

    this.hasMore = this.itens.length < this.lista.length;
  };

  marcarTodas = (checked) => {
    this.itens.map((item) => (item.marcado = checked));
    this.selecionados = this.itens.filter((i) => i.marcado === true);
  };

  cancelarInclusao = () => {
    this.inserindo = false;
    this.posEditando = -1;
  };

  incluirCarga = (novaCarga) => {
    if (this.posEditando === -1) {
      if (this.novasCargas.length === 0) this.novasCargasLength = 0;
      novaCarga.pos = this.novasCargasLength;
      this.novasCargasLength++;
      this.novasCargas.push(novaCarga);
    } else {
      this.novasCargas[this.posEditando] = novaCarga;
    }
    this.posEditando = -1;
    this.inserindo = false;
  };

  // Exportar

  getLista() {
    return this.cargasLista;
  }

  getListaCopia() {
    return toJS(this.cargasLista);
  }

  todasColunas = [
    {
      dataField: "Navio",
      text: "Navio",
      sort: true,
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Placa",
      text: "Placa",
      sort: true,
      classes: "chave-cte",
      //style:{maxWidth:'100px', overflowWrap: 'break-word'},
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Motorista",
      text: "Motorista",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Cnh",
      text: "CNH",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Cpf",
      text: "CPF",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Status",
      text: "Status",
      sort: true,
      formatter: appendFieldSpan,
      formatExtraData: "Operacao",
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },

  ];

  colunasExportacao = [
    {
      dataField: "Navio",
      text: "Navio",
      sort: true,
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Placa",
      text: "Placa",
      sort: true,
      classes: "chave-cte",
      //style:{maxWidth:'100px', overflowWrap: 'break-word'},
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Motorista",
      text: "Motorista",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Cnh",
      text: "CNH",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Cpf",
      text: "CPF",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Status",
      text: "Status",
      sort: true,
      formatter: appendFieldSpan,
      formatExtraData: "OperacaoId",
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "NomeCriador",
      text: "Cliente",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "UsuarioCriacao",
      text: "Criado por",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "UsuarioCancelamento",
      text: "Inativado por",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "EmailCriador",
      text: "Email",
      formatter: listEmailFormatter,
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "DataCriacao",
      text: "DataCriacao",
      sort: true,
      sortCaret: sortCaret,
      sortFunc : dataSortFuncString,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DataCancelamento",
      text: "Data de Cancelamento",
      sort: true,
      sortCaret: sortCaret,
      sortFunc : dataSortFuncString,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Utilizado",
      text: "Utilizado",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },

  ];

  colunasNovas = [
    {
      dataField: "Navio",
      text: "Navio",
      sort: true,
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Cnh",
      text: "CNH",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Motorista",
      text: "Motorista",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Cpf",
      text: "CPF",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Placa",
      text: "Placa",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      text: "Remover",
      formatter: (cell, row) => (
        <Button
          className="btn-primary colorButtonRed"
          onClick={() => this.handleButtonClick(row)}
        >
          X
        </Button>
      ),
    },
  ];

  handleButtonClick = (row) => {
    const indiceDoObjeto = this.novasCargas.findIndex(
      (objeto) => objeto.pos === row.pos
    );
    if (indiceDoObjeto > -1) {
      this.novasCargas.splice(indiceDoObjeto, 1);
    }
  };
}


// WEBPACK FOOTER //
// ./src/modules/carga-geral/stores/CargaGeralStore.js